export default {
  bg: `contentBg`,
  borderRadius: `lg`,
  transition: `all 250ms ease`,
  boxShadow: `1px 1px 5px 0 rgba(1,1,1,.05)`
}
